export const GET_ACTIVITIES = 'GET_ATCTIVITIES';
export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS';
export const GET_ACTIVITIES_FAIL = 'GET_ACTIVITIES_FAIL';
export const GET_UPDATED_ACTIVITY = 'GET_UPDATED_ACTIVITY';
export const DIGEST_NOTIFICATION_TEST = 'DIGEST_NOTIFICATION_TEST';

export const getActivities = () => ({
  type: GET_ACTIVITIES
});

export const getActivitiesSuccess = (activities) => ({
  type: GET_ACTIVITIES_SUCCESS,
  activities
});

export const getActivitiesFail = (error) => ({
  type: GET_ACTIVITIES_FAIL,
  error
});

export const getUpdatedActivities = (activities) => ({
  type: GET_UPDATED_ACTIVITY,
  activities
});

export const digestNotificationTest = () => ({
  type: DIGEST_NOTIFICATION_TEST
});
